export default __webpack_public_path__ + "static/media/bg4.32c7eec6.jpg";